import React from 'react';
import { useMutation, Button } from 'react-admin';

const ButtonServiceStatus = ({ record }) => {
    const [mutate, { loading }] = useMutation();
    const approve = event => mutate({
        type: 'update',
        resource: 'service',
        payload: {
            id: record.id,
            data: { status_service: 1, is_button_approve_reprove: true }
        },
    });
    const reprove = event => mutate({
        type: 'update',
        resource: 'service',
        payload: {
            id: record.id,
            data: { status_service: 2, is_button_approve_reprove: true }
        },
    });

    if (record.status_service === 0)
        return <div>
                <Button
                   label="Aprovar"
                   onClick={approve}
                   disabled={loading}
                 />
                 <Button
                    label="Reprovar"
                    onClick={reprove}
                    disabled={loading}
                  />
               </div>
    else
        return <span>
                 {record.status_service_name}
               </span>;
};

export default ButtonServiceStatus;
